import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { Typography } from '../../../../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../../context/ViewContext/ViewContext.js';
import '../../../../../utils/constants/colors.js';
import '../../../../../shared/consts/index.js';
import '../../../../../context/DynamicContext/DynamicContext.js';
import '../../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../../config/ApiEndpoint.js';
import '../../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../../context/MockContext/MockContext.js';
import '../../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../../../components/IconButton/IconButton.js';

const Item = ({ heading, StartIcon, EndIcon, message, url, }) => (jsxs("a", Object.assign({ className: 'footer-buttons-item', href: url, rel: 'noopener noreferrer', target: '_blank' }, { children: [jsx("div", Object.assign({ className: 'footer-buttons-item__icon--left' }, { children: jsx(StartIcon, {}) })), jsxs("div", Object.assign({ className: 'footer-buttons-item__typography' }, { children: [jsx(Typography, Object.assign({ as: 'h2', weight: 'regular', color: 'primary', variant: 'body_normal' }, { children: heading })), message && (jsx(Typography, Object.assign({ as: 'p', weight: 'regular', color: 'secondary' }, { children: message })))] })), EndIcon && jsx(EndIcon, { style: { height: '1.5rem', width: '1.5rem' } })] })));

export { Item };
